module.exports = __webpack_public_path__ + "static/media/Floor002-02-bg.f555251e.jpg";